// ===================================================================
// INDIAN_CITIES — top ~160 cities by metro / tier-1 / tier-2 footprint.
// Used by <CitySelect /> for autocomplete on enquiry / contact / tax /
// ad-booking / stock-research forms. Free text still accepted by the
// underlying datalist so any village/town name also works.
// ===================================================================
const INDIAN_CITIES = [
  // Tier-1 / Metros
  'Mumbai', 'Delhi', 'Bengaluru', 'Hyderabad', 'Chennai', 'Kolkata', 'Pune', 'Ahmedabad',
  // Tier-2 / state capitals + major cities
  'Surat', 'Jaipur', 'Lucknow', 'Kanpur', 'Nagpur', 'Indore', 'Thane', 'Bhopal',
  'Visakhapatnam', 'Patna', 'Vadodara', 'Ghaziabad', 'Ludhiana', 'Agra', 'Nashik', 'Faridabad',
  'Meerut', 'Rajkot', 'Kalyan', 'Vasai-Virar', 'Varanasi', 'Srinagar', 'Aurangabad', 'Dhanbad',
  'Amritsar', 'Navi Mumbai', 'Allahabad', 'Prayagraj', 'Ranchi', 'Howrah', 'Coimbatore', 'Jabalpur',
  'Gwalior', 'Vijayawada', 'Jodhpur', 'Madurai', 'Raipur', 'Kota', 'Guwahati', 'Chandigarh',
  'Solapur', 'Hubli–Dharwad', 'Mysuru', 'Tiruchirappalli', 'Bareilly', 'Aligarh', 'Tiruppur', 'Gurgaon',
  'Gurugram', 'Noida', 'Greater Noida', 'Moradabad', 'Jalandhar', 'Bhubaneswar', 'Salem', 'Mira-Bhayandar',
  'Warangal', 'Guntur', 'Bhiwandi', 'Saharanpur', 'Gorakhpur', 'Bikaner', 'Amravati', 'Noida Extension',
  'Jamshedpur', 'Bhilai', 'Cuttack', 'Firozabad', 'Kochi', 'Nellore', 'Bhavnagar', 'Dehradun',
  'Durgapur', 'Asansol', 'Rourkela', 'Nanded', 'Kolhapur', 'Ajmer', 'Akola', 'Gulbarga',
  'Jamnagar', 'Ujjain', 'Loni', 'Siliguri', 'Jhansi', 'Ulhasnagar', 'Jammu', 'Sangli-Miraj-Kupwad',
  'Mangaluru', 'Erode', 'Belagavi', 'Ambattur', 'Tirunelveli', 'Malegaon', 'Gaya', 'Udaipur',
  'Davanagere', 'Kakinada', 'Maheshtala', 'Rajpur Sonarpur', 'Bokaro Steel City', 'South Dumdum',
  'Patiala', 'Bhagalpur', 'Muzaffarnagar', 'Latur', 'Dhule', 'Rohtak', 'Korba', 'Bhilwara',
  'Berhampur', 'Muzaffarpur', 'Ahmednagar', 'Mathura', 'Kollam', 'Avadi', 'Kadapa', 'Kamarhati',
  'Sambalpur', 'Bilaspur', 'Shahjahanpur', 'Satara', 'Bijapur', 'Rampur', 'Shivamogga', 'Chandrapur',
  'Junagadh', 'Thrissur', 'Alwar', 'Bardhaman', 'Kulti', 'Kakinada', 'Nizamabad', 'Parbhani',
  'Tumkur', 'Khammam', 'Ozhukarai', 'Bihar Sharif', 'Panipat', 'Darbhanga', 'Bally', 'Aizawl',
  'Dewas', 'Ichalkaranji', 'Karnal', 'Bathinda', 'Jalna', 'Eluru', 'Barasat', 'Kirari Suleman Nagar',
  'Purnia', 'Satna', 'Mau', 'Sonipat', 'Farrukhabad', 'Sagar', 'Rourkela', 'Durg',
  'Imphal', 'Ratlam', 'Hapur', 'Anantapur', 'Arrah', 'Karimnagar', 'Etawah', 'Ambernath',
  'North Dumdum', 'Bharatpur', 'Begusarai', 'New Delhi', 'Gandhidham', 'Baranagar', 'Tiruvottiyur', 'Pondicherry',
  'Sikar', 'Thoothukudi', 'Rewa', 'Mirzapur', 'Raichur', 'Pali', 'Ramagundam', 'Silchar',
  'Haridwar', 'Vijayanagaram', 'Tenali', 'Nagercoil', 'Sri Ganganagar', 'Karawal Nagar', 'Mango', 'Thanjavur',
  'Bulandshahr', 'Uluberia', 'Murwara (Katni)', 'Sambhal', 'Singrauli', 'Nadiad', 'Secunderabad', 'Naihati',
  'Yamunanagar', 'Bidhannagar', 'Pallavaram', 'Bidar', 'Munger', 'Panchkula', 'Burhanpur', 'Raurkela',
  'Kharagpur', 'Dindigul', 'Gandhinagar', 'Hospet', 'Hosur', 'Nagaon', 'Sasaram', 'Hajipur',
  'Port Blair', 'Bhimavaram', 'Mahbubnagar', 'Mahesana', 'Ambala', 'Pondicherry', 'Shahjahanpur', 'Vellore',
  'Tirupati', 'Hapur', 'Anand', 'Itarsi', 'Vapi', 'Bharuch', 'Morbi', 'Veraval',
  'Ratnagiri', 'Daman', 'Diu', 'Margao', 'Panaji', 'Mapusa', 'Vasco da Gama', 'Kannur',
  'Palakkad', 'Kottayam', 'Alappuzha', 'Malappuram', 'Kasaragod', 'Manjeri', 'Thalassery',
];

export default INDIAN_CITIES;
